import { cva } from "@mobsuccess-devops/styled-system/css";
import { styled } from "@mobsuccess-devops/styled-system/jsx";

const bodyStyle = cva({
  base: {
    textStyle: "body",
    color: "interface",
  },
});

export const Body = styled("p", bodyStyle);
